import { InfoCircleFilled } from '@ant-design/icons';
import { colors } from '@thndr/design-system';
import { useMySubs } from '@thndr/namespace/subscriptions';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MarketName } from '::root/libs/namespace/subscriptions/src/types';
import * as Styles from './deprecation-banner-styles';

const THNDRX_URL = 'https://x.thndr.app';
// Read by elements laid out against the fixed header (page content, asset top
// header) so they sit below the fixed banner.
const BANNER_HEIGHT_VAR = '--web-deprecation-banner-height';

interface DeprecationBannerProps {
  // Pin below a fixed-position header (HeaderV2); in-flow headers don't need it.
  withHeaderOffset?: boolean;
}

// Shown to subscribers only: web.thndr.app is being deprecated in favor of x.thndr.app.
export function DeprecationBanner({
  withHeaderOffset = true,
}: DeprecationBannerProps) {
  const { t } = useTranslation('common');
  const market =
    typeof window !== 'undefined'
      ? (localStorage.getItem('market') as MarketName) || MarketName.EGYPT
      : MarketName.EGYPT;
  const { mySubs } = useMySubs(undefined, market);

  const isVisible = mySubs?.length > 0;

  useEffect(() => {
    if (!withHeaderOffset || !isVisible) return;
    const root = document.documentElement;
    root.style.setProperty(BANNER_HEIGHT_VAR, `${Styles.BANNER_HEIGHT}px`);
    return () => {
      root.style.removeProperty(BANNER_HEIGHT_VAR);
    };
  }, [withHeaderOffset, isVisible]);

  if (!isVisible) return null;

  return (
    <Styles.Container withHeaderOffset={withHeaderOffset}>
      <Styles.Content>
        <InfoCircleFilled
          style={{
            color: colors.blue60,
            marginInlineEnd: '10px',
            fontSize: '16px',
          }}
        />
        <Styles.Paragraph>
          {t('webDeprecation.description')}{' '}
          <Styles.Link
            href={THNDRX_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('webDeprecation.link')}
          </Styles.Link>
        </Styles.Paragraph>
      </Styles.Content>
    </Styles.Container>
  );
}

export default DeprecationBanner;
